define('models/pages/multi-account/params',['require','models/base/model','lib/utils','underscore'],function(require) {
    'use strict';

    var Model = require('models/base/model');
    var utils = require('lib/utils');
    var _ = require('underscore');

    var Params = Model.extend({
        defaults: {
            fromDate: null,
            toDate: null,
            currencyCode: null
        },

        urlParams: function() {
            return {
                currencyCode: this.get('currencyCode'),
                fromDate: utils.fmtDate(this.get('fromDate')),
                toDate: utils.fmtDate(this.get('toDate'))
            };
        },

        parse: function(params) {
            var data = {
                fromDate: utils.parseDate(params.fromDate),
                toDate: utils.parseDate(params.toDate),
                currencyCode: (params.currencyCode || 'USD').toUpperCase()
            };

            if (!_.isDate(data.toDate)) {
                data.toDate = new Date();
            }

            if (!_.isDate(data.fromDate)) {
                data.fromDate = utils.addDays(data.toDate, -14);
            }
            return data;
        },

        validate: function(attrs) {

            return !(attrs.fromDate && attrs.toDate && attrs.currencyCode);
        }
    });

    return Params;
});


